var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.37583 2.24512L4.50956 6.83814M4.16279 2.24512H11.8372C12.4767 2.24512 13 2.76837 13 3.40791V4.68698C13 5.15209 12.7093 5.73349 12.4186 6.02419L9.9186 8.23349C9.56977 8.52418 9.33721 9.10558 9.33721 9.5707V12.0707C9.33721 12.4195 9.10465 12.8846 8.81395 13.0591L8 13.5823C7.24419 14.0474 6.19767 13.5242 6.19767 12.594V9.51256C6.19767 9.10558 5.96512 8.58232 5.73256 8.29163L3.52326 5.96605C3.23256 5.67535 3 5.15209 3 4.80326V3.46605C3 2.76837 3.52326 2.24512 4.16279 2.24512Z",
    stroke: "#FAFAFA",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.6b91b4fa9a39fe9a46567cf029c7de88.svg";
export { ForwardRef as ReactComponent };